<nz-modal [nzTitle]="undefined" [nzFooter]="null" [nzMaskClosable]="false" [nzClosable]="false" [(nzVisible)]="visible"
  (nzOnCancel)="visible = false">
  <ng-container *nzModalContent>
    <nz-result [nzIcon]="resultIcon">
      <ng-template #resultIcon>
        <nz-progress [nzPercent]="progress" nzStatus="active" nzType="circle"></nz-progress>
      </ng-template>
      <div nz-result-title>
        <nz-spin nzSimple></nz-spin>
        <span nz-icon nzType="coffee"></span>
        We are setting up your sample data, this may take a few minutes, please wait...
      </div>
      <div nz-result-extra> </div>
    </nz-result>
  </ng-container>
</nz-modal>
